import * as Types from '../actions/Types'
import * as Constants from '../../helpers/Constants'

const INITIAL_STATE = {
  community: null,
  apartments: [],
  bookingSystems: [],
  bookingSystemsFetched: false,
  laundrySystem: null,
  informationItems: [],
  informationItemsFetched: false,
  posts: [],
  postsFetched: false,
  fetched: false,
  isFetching: false
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action

  switch (type) {
  case Types.GET_SELF:
    return {
      ...state,
      fetched: false,
      isFetching: true
    }
  case Types.GET_COMMUNITY_SUCCESS:
    return {
      ...state,
      community: payload
    }
  case Types.TOGGLE_LAUNDRY_VISIBILITY_SUCCESS:
    return {
      ...state,
      community: {
        ...state.community,
        showApartmentInLaundry: payload
      }
    }
  case Types.GET_LAUNDRY_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      laundrySystem: payload
    }
  case Types.GET_INFORMATION_ITEMS_SUCCESS:
    return {
      ...state,
      informationItems: payload,
      informationItemsFetched: true
    }
  case Types.GET_POSTS_SUCCESS:
    return {
      ...state,
      posts: payload,
      postsFetched: true
    }
  case Types.CREATE_USER_SUCCESS:
    return {
      ...state,
      community: {
        ...state.community,
        apartments: state.community.apartments.map(item => {
          if (item.id.toString() === payload.apartmentId.toString()) {
            item.users = [...item.users, payload]
          }

          return item
        })
      }
    }
  case Types.CREATE_POST_SUCCESS:
    return {
      ...state,
      posts: [{ ...payload, comments: [], likes: [] }, ...state.posts]
    }
  case Types.DELETE_POST_SUCCESS:
    return {
      ...state,
      posts: state.posts.filter(
        item => item.id.toString() !== payload.toString()
      )
    }
  case Types.DELETE_USER_SUCCESS:
    return {
      ...state,
      community: {
        ...state.community,
        apartments: state.community.apartments.map(item => {
          return {
            ...item,
            users: item.users.filter(
              u => u.id.toString() !== payload.toString()
            )
          }
        })
      }
    }
  case Types.UPDATE_USER_SUCCESS:
    return {
      ...state,
      community: {
        ...state.community,
        apartments: state.community.apartments.map(item => {
          return {
            ...item,
            users: item.users.map(u => {
              if (u.id.toString() === payload.id.toString()) {
                return payload
              }

              return u
            })
          }
        })
      }
    }
  case Types.UPDATE_LAUNDRY_TIME_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        times: state.laundrySystem.times.map(item => {
          if (item.id === payload.id) {
            return payload
          }

          return item
        })
      }
    }
  case Types.CREATE_LAUNDRY_TIME_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        times: [...state.laundrySystem.times, payload]
      }
    }
  case Types.DELETE_LAUNDRY_TIME_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        times: state.laundrySystem.times.filter(item => item.id !== payload)
      }
    }
  case Types.UPDATE_LAUNDRY_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        laundries: state.laundrySystem.laundries.map(item => {
          if (item.id === payload.id) {
            return payload
          }

          return item
        })
      }
    }
  case Types.CREATE_LAUNDRY_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        laundries: [...state.laundrySystem.laundries, payload]
      }
    }
  case Types.DELETE_LAUNDRY_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        laundries: state.laundrySystem.laundries.filter(
          item => item.id !== payload
        )
      }
    }
  case Types.SET_SELECTED_COMMUNITY:
    return {
      ...state,
      selectedCommunity: payload
    }
  case Types.UPDATE_LAUNDRY_RULES_SUCCESS:
    return {
      ...state,
      laundrySystem: {
        ...state.laundrySystem,
        laundryRule: payload
      }
    }
  case Types.UPDATE_INFORMATION_ITEM_SUCCESS:
    return {
      ...state,
      informationItems: state.informationItems.map(item => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      })
    }
  case Types.CREATE_INFORMATION_ITEM_SUCCESS:
    return {
      ...state,
      informationItems: [...state.informationItems, payload]
    }
  case Types.DELETE_INFORMATION_ITEM_SUCCESS:
    return {
      ...state,
      informationItems: state.informationItems.filter(
        item => item.id !== payload
      )
    }
  case Types.CREATE_BOOKING_SUCCESS:
    return {
      ...state,
      communities: addBooking(
        state.communities,
        payload,
        state.selectedCommunity
      )
    }
  case Types.DELETE_BOOKING_SUCCESS:
    return {
      ...state,
      communities: deleteBooking(state.communities, payload)
    }
  case Types.GET_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: payload,
      bookingSystemsFetched: true
    }
  case Types.CREATE_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: [
        ...state.bookingSystems,
        {
          id: payload.object.id,
          bookableObject: {
            ...payload.object,
            times: payload.times,
            bookings: []
          }
        }
      ]
    }
  case Types.DELETE_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: state.bookingSystems.filter(item => item.id !== payload)
    }
  case Types.UPDATE_BOOKING_SYSTEM_SUCCESS:
    return {
      ...state,
      bookingSystems: state.bookingSystems.map(item => {
        if (item.id === payload.bookableId) {
          return {
            id: item.id,
            bookableObject: {
              ...payload.data,
              times: item.bookableObject.times,
              bookings: item.bookableObject.bookings
            }
          }
        }

        return item
      })
    }
  case Types.CREATE_BOOKING_SYSTEM_TIME_SUCCESS:
    return {
      ...state,
      bookingSystems: state.bookingSystems.map(item => {
        if (item.id === payload.bookableId) {
          return {
            id: item.id,
            bookableObject: {
              ...item.bookableObject,
              times: [...item.bookableObject.times, payload.data]
            }
          }
        }

        return item
      })
    }
  case Types.UPDATE_BOOKING_SYSTEM_TIME_SUCCESS:
    return {
      ...state,
      bookingSystems: state.bookingSystems.map(item => {
        if (item.id === payload.bookableId) {
          return {
            id: item.id,
            bookableObject: {
              ...item.bookableObject,
              times: item.bookableObject.times.map(time => {
                if (time.id === payload.data.id) {
                  return payload.data
                }

                return time
              })
            }
          }
        }

        return item
      })
    }
  case Types.DELETE_BOOKING_SYSTEM_TIME_SUCCESS:
    return {
      ...state,
      bookingSystems: state.bookingSystems.map(item => {
        if (item.id === payload.bookableId) {
          return {
            id: item.id,
            bookableObject: {
              ...item.bookableObject,
              times: item.bookableObject.times.filter(
                time => time.id !== payload.timeId
              )
            }
          }
        }

        return item
      })
    }
  case Types.RESET_APARTMENT_SUCCESS:
    return {
      ...state,
      community: {
        ...state.community,
        apartments: state.community.apartments.map(item => {
          if (item.id === payload.id) {
            return {
              ...item,
              code: payload.code,
              users: []
            }
          }

          return item
        })
      }
    }
  case Types.SIGN_OUT_USER:
    return INITIAL_STATE
  case Types.TOGGLE_APARTMENT_VISIBILITY_SUCCESS:
    return {
      ...state,
      communities: {
        ...state.communities,
        [payload.communityId]: {
          ...state.communities[payload.communityId],
          apartments: state.communities[payload.communityId].apartments.map(a => {
            if (a.id.toString() === payload.apartmentId.toString()) {
              return {
                ...a,
                showInLaundryBookings: payload.visible
              }
            }
            return a
          })
        }
      }
    }
  default:
    return state
  }
}

function parseCommunities(communities) {
  const parsedCommunities = {}

  communities.forEach(community => {
    community.bookingSystems = {
      fetched: false,
      systems: []
    }
    community.posts = {
      fetched: false,
      items: []
    }
    community.laundrySystem = {
      fetched: false,
      times: [],
      rules: null,
      laundries: [],
      bookings: []
    }
    community.informationItems = {
      fetched: false,
      items: []
    }
    parsedCommunities[community.id] = community
  })

  return parsedCommunities
}

function addLaundrySystem(communities, payload) {
  const { data, communityId } = payload

  if (communities[communityId]) {
    communities[communityId].laundrySystem = {
      fetched: true,
      times: data.times,
      rule: data.laundryRule,
      laundries: data.laundries,
      bookings: data.bookings
    }
  }

  return { ...communities }
}

function addInformationItems(communities, payload) {
  const { data, communityId } = payload

  if (communities[communityId]) {
    communities[communityId].informationItems = {
      fetched: true,
      items: data
    }
  }

  return { ...communities }
}

function addPosts(communities, payload) {
  const { data, communityId } = payload

  if (communities[communityId]) {
    communities[communityId].posts = {
      fetched: true,
      items: data
    }
  }

  return { ...communities }
}

function resetApartment(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].apartments = communities[
      payload.communityId
    ].apartments.map(a => {
      console.log(a, payload.data)
      if (a.id.toString() === payload.data.id.toString()) {
        return {
          ...payload.data,
          users: []
        }
      }

      return a
    })
  }

  return { ...communities }
}

function addUser(communities, user, selectedCommunity) {
  communities[selectedCommunity].apartments = communities[
    selectedCommunity
  ].apartments.map(a => {
    if (user.apartmentId.toString() === a.id.toString()) {
      a.users = [...a.users, user]
    }

    return a
  })

  return { ...communities }
}

function deleteUser(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].apartments = communities[
      payload.communityId
    ].apartments.map(a => {
      a.users = a.users.filter(user => user.id !== payload.userId)
      return a
    })
  }

  return { ...communities }
}

function updateUser(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].apartments = communities[
      payload.communityId
    ].apartments.map(a => {
      if (a.id.toString() === payload.user.apartmentId.toString()) {
        a.users = a.users.map(u => {
          if (payload.user.id.toString() === u.id.toString()) {
            return payload.user
          }

          return u
        })
      }

      return a
    })
  }

  return { ...communities }
}

function addLaundryTime(communities, laundryTime, selectedCommunity) {
  communities[selectedCommunity].laundrySystem.times = [
    ...communities[selectedCommunity].laundrySystem.times,
    { ...laundryTime, days: Constants.ALL_DAYS }
  ]

  return { ...communities }
}

function updateLaundryTime(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.times = communities[
      payload.communityId
    ].laundrySystem.times.map(laundryTime => {
      if (laundryTime.id.toString() === payload.laundryTimeId.toString()) {
        return payload.laundryTime
      }

      return laundryTime
    })
  }

  return { ...communities }
}

function deleteLaundryTime(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.times = communities[
      payload.communityId
    ].laundrySystem.times.filter(
      laundryTime => laundryTime.id !== payload.laundryTimeId
    )
  }

  return { ...communities }
}

function addLaundry(communities, laundry, selectedCommunity) {
  communities[selectedCommunity].laundrySystem.laundries = [
    ...communities[selectedCommunity].laundrySystem.laundries,
    laundry
  ]

  return { ...communities }
}

function updateLaundry(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.laundries = communities[
      payload.communityId
    ].laundrySystem.laundries.map(laundry => {
      if (laundry.id.toString() === payload.laundryId.toString()) {
        return payload.laundry
      }

      return laundry
    })
  }

  return { ...communities }
}

function deleteLaundry(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.laundries = communities[
      payload.communityId
    ].laundrySystem.laundries.filter(
      laundry => laundry.id !== payload.laundryId
    )
  }

  return { ...communities }
}

function updateLaundryRules(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.laundryRule =
      payload.laundryRules
  }

  return { ...communities }
}

function addInformationItem(communities, informationItem, selectedCommunity) {
  communities[selectedCommunity].informationItems.items = [
    ...communities[selectedCommunity].informationItems.items,
    informationItem
  ]

  return { ...communities }
}

function updateInformationItem(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].informationItems.items = communities[
      payload.communityId
    ].informationItems.items.map(informationItem => {
      if (
        informationItem.id.toString() === payload.informationItemId.toString()
      ) {
        return payload.informationItem
      }

      return informationItem
    })
  }

  return { ...communities }
}

function deleteInformationItem(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].informationItems.items = communities[
      payload.communityId
    ].informationItems.items.filter(
      informationItem => informationItem.id !== payload.informationItemId
    )
  }

  return { ...communities }
}

function addBooking(communities, payload, selectedCommunity) {
  communities[selectedCommunity].laundrySystem.bookings = [
    ...communities[selectedCommunity].laundrySystem.bookings,
    payload
  ]

  return { ...communities }
}

function deleteBooking(communities, payload) {
  if (communities[payload.communityId]) {
    communities[payload.communityId].laundrySystem.bookings = communities[
      payload.communityId
    ].laundrySystem.bookings.filter(
      booking => booking.id.toString() !== payload.bookingId.toString()
    )
  }

  return { ...communities }
}

function addPost(communities, payload) {
  const { data, communityId } = payload

  if (communities[communityId]) {
    communities[communityId].posts.items = [
      { ...data, comments: [], likes: [] },
      ...communities[communityId].posts.items
    ]
  }

  return { ...communities }
}

function deletePost(communities, payload) {
  const { postId, communityId } = payload

  if (communities[communityId]) {
    communities[communityId].posts.items = communities[
      communityId
    ].posts.items.filter(post => postId.toString() !== post.id.toString())
  }

  return { ...communities }
}

function getBookingSystems(communities, payload) {
  if (communities[payload.communityId]) {
    const systems = payload.data.map(system => system.bookableObject)

    communities[payload.communityId].bookingSystems = {
      fetched: true,
      systems
    }
  }

  return { ...communities }
}

function addBookingSystem(communities, payload) {
  if (communities[payload.communityId]) {
    const system = {
      id: payload.data.object.id,
      name: payload.data.object.name,
      maxBookings: payload.data.object.maxBookings,
      bookingRange: payload.data.object.bookingRange,
      times: payload.data.times,
      bookings: []
    }

    communities[payload.communityId].bookingSystems.systems.push(system)
  }

  return { ...communities }
}

// NOTE: One booking system can belong to many communities (houses)
function deleteBookingSystem(communities, bookableId) {
  Object.keys(communities).forEach(key => {
    communities[key].bookingSystems.systems = communities[
      key
    ].bookingSystems.systems.filter(
      system => system.id.toString() !== bookableId.toString()
    )
  })

  return { ...communities }
}

function updateBookingSystem(communities, payload) {
  Object.keys(communities).forEach(key => {
    communities[key].bookingSystems.systems = communities[
      key
    ].bookingSystems.systems.map(system => {
      if (system.id.toString() === payload.bookableId.toString()) {
        system.name = payload.data.name
        system.maxBookings = payload.data.maxBookings
        system.bookingRange = payload.data.bookingRange
      }

      return system
    })
  })

  return { ...communities }
}

function addTimeToBookingSystem(communities, payload) {
  Object.keys(communities).forEach(key => {
    communities[key].bookingSystems.systems = communities[
      key
    ].bookingSystems.systems.map(system => {
      if (system.id.toString() === payload.bookableId.toString()) {
        system.times = [...system.times, payload.data]
      }

      return system
    })
  })

  return { ...communities }
}

function updateBookingSystemTime(communities, payload) {
  Object.keys(communities).forEach(key => {
    communities[key].bookingSystems.systems = communities[
      key
    ].bookingSystems.systems.map(system => {
      if (system.id.toString() === payload.bookableId.toString()) {
        system.times = system.times.map(time => {
          if (time.id.toString() === payload.data.id.toString()) {
            return payload.data
          }

          return time
        })
      }

      return system
    })
  })

  return { ...communities }
}

function deleteBookingSystemTime(communities, payload) {
  Object.keys(communities).forEach(key => {
    communities[key].bookingSystems.systems = communities[
      key
    ].bookingSystems.systems.map(system => {
      if (system.id.toString() === payload.bookableId.toString()) {
        system.times = system.times.filter(
          time => time.id.toString() !== payload.timeId.toString()
        )
      }

      return system
    })
  })

  return { ...communities }
}



// WEBPACK FOOTER //
// ./src/components/reducers/Data.js